import { atom } from 'jotai'

export const notificationTaskIdAtom = atom({
  taskId: null,
  commentId: null,
  documentId: null,
})
